import React from 'react';

import { downloadURL } from 'services/Utils';

import MediaModal from '../MediaModal';
import GroupedMediaList from './components/Lists/GroupedMediaList';
import MediaList from './components/Lists/MediaList';
import { MediaSizeEnum, type MediaGalleryProps, type MediaItem, type MediaListItem } from './types';

const MediaGallery: React.FC<MediaGalleryProps> = (props) => {
  const galleryProps: MediaGalleryProps = { onClipping: () => undefined, mediaSize: MediaSizeEnum.DEFAULT, ...props };
  const { groupedByType, onDownload, withPreview, onPreview, mediaList = [], hideDownload } = galleryProps;

  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedMedia, setSelectedMedia] = React.useState<MediaItem>();

  const FBMedias = React.useMemo(
    () =>
      mediaList.reduce<MediaItem[]>((acc, { data }) => {
        if (data?.path || data?.archived) {
          acc.push(data);
        }
        return acc;
      }, []),
    [mediaList]
  );

  const handleOnDownload = React.useCallback(
    (media: MediaListItem) => {
      if (typeof onDownload === 'function') {
        onDownload(media);
      } else if (media.data.path) {
        downloadURL(media.data.path, media.data.filename);
      }
    },
    [onDownload]
  );

  const downloadHandler = hideDownload ? undefined : handleOnDownload;

  const closePreviewModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleOnPreview = React.useCallback(
    (media: MediaListItem) => {
      const { data } = media;
      if (data?.path || data?.archived) {
        if (withPreview) {
          setModalOpen(true);
          setSelectedMedia(media.data);
        }
        onPreview?.(media);
      }
    },
    [onPreview, withPreview]
  );

  return (
    <React.Fragment>
      {groupedByType && <GroupedMediaList {...galleryProps} onDownload={downloadHandler} onPreview={handleOnPreview} />}
      {!groupedByType && <MediaList {...galleryProps} onDownload={downloadHandler} onPreview={handleOnPreview} />}
      {withPreview && modalOpen && selectedMedia && (
        <MediaModal
          medias={FBMedias}
          close={closePreviewModal}
          footer={null}
          selectedMedia={selectedMedia}
          selectMedia={setSelectedMedia}
        />
      )}
    </React.Fragment>
  );
};

export default MediaGallery;
